import Vue from 'vue'
import Vuex from 'vuex'
import configs from './configs';
import {DB} from '@/plugins/dbClass'; 
import { CredentialLogin, UserData } from '@/plugins/utils/loginUtils';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loadingFlag: false,
    error: {flag: false, text: "", status: "error"},
    configs: configs,
    db: null as null | DB,
    username: "",
    password: "",
    token: "",
    separator_aux: ["*[---aux---]*","\n\n---aux---\n\n", "---aux---\n\n"],
    userData: {} as UserData,
    version: "v1.1.58"
  },
  mutations: {
    setLoading(state, loading: boolean) {
      state.loadingFlag = loading;
    },
    setError(state, error: {flag: boolean; text: string; status: string}) {
      state.error.flag = error.flag;
      state.error.text = error.text;
      state.error.status = error.status;
      if(error.flag){
        setTimeout(()=>{
          state.error.flag = false;
          state.error.text = "";
        },5000);
      }
    },
    setDB(state, instance: DB) {
      state.db = instance as DB;
    },
    setToken(state, token: string){
      state.token = token;
    },
    setCredentials(state, credentials: CredentialLogin){
      state.username = credentials.username;
      state.password = credentials.password;
    },
    setUserData(state, user: UserData){
      state.userData = user;
    }
  },
  actions: {
    init({ commit }, cb: Function) {
      commit("setDB", new DB(cb));
    },
  },
  getters: {
    separatorAux(state): string[]{
      return state.separator_aux;
    },
    loadingFlag(state): boolean {
      return state.loadingFlag;
    },
    error(state): {flag: boolean; text: string; status: string} {
      return state.error;
    },
    configs(state): object {
      return state.configs;
    },
    db(state): DB | null{
      return state.db;
    },
    token(state): string {
      return state.token;
    },
    username(state): string {
      return state.username;
    },
    password(state): string {
      return state.password;
    },
    userData(state): UserData{
      return state.userData;
    },
    version(state): string {
      return state.version
    }
  },
  modules: {
  }
});

export default store;